import React from 'react';
import type { FC } from 'react';
import { SiteAuthProvider } from '@wix/cli-auth';
import { useProjectModel } from '../../model.js';
import { EnvRemove } from './EnvRemove.js';

export const EnvRemoveCommand: FC<{
  variableKey: string;
}> = ({ variableKey }) => {
  const {
    model: { config },
  } = useProjectModel();

  let commandTree = <EnvRemove variableKey={variableKey} />;

  if (config.projectType === 'Site') {
    commandTree = (
      <SiteAuthProvider siteId={config.siteId}>{commandTree}</SiteAuthProvider>
    );
  }

  return commandTree;
};
